// Type Imports
import type { ChildrenType } from '@core/types'

// React Imports
import { useState, useEffect } from 'react'

// Router Imports
import { useLocation, useNavigate } from 'react-router-dom'

// Config Imports
// import themeConfig from '@configs/themeConfig'

const GuestOnlyRoute = ({ children }: ChildrenType) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    const session = localStorage.getItem('accessToken')
    const expiresIn = localStorage.getItem('expiresIn')

    if (session && expiresIn) {
      setIsAuthenticated(true)
      // If user is already authenticated and trying to access auth pages under /cms,
      // redirect to /cms (which will redirect to home page)

      if (pathname.startsWith('/cms/login') ||
          pathname.startsWith('/cms/register') ||
          pathname.startsWith('/cms/forgot-password') ||
          pathname.startsWith('/cms/account-')) {
        navigate('/cms', { replace: true })
      } else {
        // navigate(themeConfig.homePageUrl, { replace: true })
      }
    }
  }, [pathname, navigate])

  if (isAuthenticated) {
    return null
  }

  return <>{children}</>
}

export default GuestOnlyRoute
